import { getDisplayMessages } from '../configuration/lang/langSlice';
import { useAppSelector } from '../configuration/setup/hooks';

/*

intl-msg:notifications.type
choose from "info", "success", "warning" or "danger"

intl-msg:notifications.serviceMessage
If empty, no message will be shown

intl-msg:notifications.serviceMessage.more
If empty, no more button and more content will be shown

*/

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const translationKeyExistsOrFallback = (key: string, fallback: any | undefined): string | undefined => {
    const localizedMessages = useAppSelector(getDisplayMessages);
    return localizedMessages && localizedMessages[key] !== undefined ? localizedMessages[key] : fallback;
};

const useServiceMessage = () => {
    const serviceMessage = translationKeyExistsOrFallback('intl-msg:notifications.serviceMessage', undefined);
    const hasMore = translationKeyExistsOrFallback('intl-msg:notifications.serviceMessage.more', false);
    const messageType = translationKeyExistsOrFallback('intl-msg:notifications.serviceMessage.type', undefined);

    return {
        serviceMessage,
        messageType,
        hasMore,
    };
};

export default useServiceMessage;
